import { Fragment } from "react";
import "./css/legal.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Banner from "../../images/servicio/calidad.webp";
import BannerMobile from "../../images/servicio/calidad-movil.webp";
import Image from "react-bootstrap/Image";

function InfoRescueSheets() {
    return (
        <Fragment>
            <Container fluid={true} className="banner-legal">
                <Row>
                    <Col md={12} className="px-0">
                        <Card>
                            <Image
                                src={Banner}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-none d-sm-block img2"
                                fluid
                            />
                            <Image
                                src={BannerMobile}
                                alt="Hyundai Banner"
                                title="Hyundai Banner"
                                className="d-block d-sm-none"
                                fluid
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-legal w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="legal-banner-titulo">
                                            Política de Cookies
                                        </h1>
                                        <br />
                                        <h2 className="legal-banner-subtitulo">Hyundai Ecuador</h2>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <br></br>
            <br></br>
            <br></br>
            <Container className="legales">
                <Row>
                    <Col md={12}>
                        <Container className="pb-3">
                            <Row>
                                <Col md={12} className="mt-3">
                                    <p className="legal-texto">
                                        Nos preocupamos por tu privacidad y queremos que entiendas cómo utilizamos las cookies
                                        para mejorar tu experiencia en nuestro sitio web. Esta política te explica qué son las cookies,
                                        cómo las usamos y qué opciones tienes para controlarlas. No recopilamos información personal
                                        identificable a través de nuestras cookies. Los datos recopilados son exclusivamente
                                        datos de navegación y se utilizan para comprender sus preferencias y mejorar su experiencia
                                        en futuras visitas.
                                    </p>
                                    <p className="legal-texto-bold">
                                        1. ¿Qué son las cookies?
                                    </p>
                                    <p className="legal-texto">
                                        Las cookies son pequeños archivos de texto que se almacenan en tu ordenador o dispositivo móvil
                                        cuando visitas un sitio web. Actúan como una especie de memoria para el sitio, permitiéndole
                                        recordar tus preferencias (como el idioma o el tamaño de la letra), información de inicio de
                                        sesión y otros datos útiles que te ayudan a navegar de forma más eficiente.
                                    </p>
                                    <p className="legal-texto-bold">
                                        2. ¿Cómo usamos las cookies?
                                    </p>
                                    <p className="legal-texto">
                                        Utilizamos cookies para diferentes propósitos, entre ellos:
                                        <ul>
                                            <li><b>Funcionalidad esencial:</b> Algunas cookies son imprescindibles para que nuestro sitio web funcione correctamente. Permiten que navegues entre páginas, accedas a áreas seguras y utilices funciones básicas.</li>
                                            <li><b>Personalización:</b> Las cookies nos ayudan a recordar tus preferencias, como el idioma que has elegido o la región en la que te encuentras, para ofrecerte una experiencia más personalizada.</li>
                                            <li><b>Rendimiento:</b> Estas cookies recopilan información anónima sobre cómo los usuarios interactúan con nuestro sitio web. Nos ayudan a entender qué páginas son las más populares, qué enlaces se utilizan con más frecuencia y si los usuarios encuentran algún error. Esto nos permite mejorar el rendimiento y el diseño de nuestro sitio.</li>
                                            <li><b>Análisis:</b> Utilizamos cookies de análisis para obtener información sobre cómo se utiliza nuestro sitio web, como el número de visitantes, de dónde vienen y qué páginas visitan. Esto nos ayuda a mejorar el funcionamiento del sitio.</li>
                                        </ul>
                                    </p>
                                    <p className="legal-texto-bold">
                                        3. ¿Qué tipos de cookies utilizamos?
                                    </p>
                                    <p className="legal-texto">
                                        <ul>
                                            <li><b>Cookies propias: </b> Son las que instalamos nosotros mismos.</li>
                                            <li><b>Cookies de terceros: </b> Son cookies instaladas por otros servicios que utilizamos en nuestro sitio web, como: </li>
                                            <ul>
                                                <li>Google Analytics para análisis del tráfico del sitio web</li>
                                                <li>Botones de redes sociales para compartir contenido en Facebook o Twitter</li>
                                            </ul>
                                        </ul>
                                        Ten en cuenta que no controlamos las cookies utilizadas por terceros. Te recomendamos que consultes sus propias políticas de privacidad para obtener más información sobre cómo utilizan las cookies.
                                    </p>
                                    <p className="legal-texto-bold">
                                        4. ¿Cómo puedes controlar las cookies?
                                    </p>
                                    <p className="legal-texto">
                                        Tienes varias opciones para controlar las cookies:
                                        <ul>
                                            <li><b>Configuración del navegador: </b> La mayoría de los navegadores web te permiten 
                                            gestionar las cookies a través de la configuración. Puedes bloquear todas las cookies, 
                                            permitir solo las cookies propias o eliminar las cookies existentes. Consulta la sección 
                                            de ayuda de tu navegador para obtener instrucciones específicas.</li>
                                            <li><b>Herramientas de terceros: </b> Existen herramientas online que te permiten gestionar las cookies de diferentes sitios web. </li>
                                        </ul>
                                    </p>
                                    <p className="legal-texto-bold">
                                        5. Consentimiento
                                    </p>
                                    <p className="legal-texto">
                                        Te pediremos tu consentimiento explícito antes de instalar cualquier cookie que no sea 
                                        estrictamente necesaria para el funcionamiento básico de nuestro sitio web. 
                                        Puedes retirar tu consentimiento en cualquier momento a través de la configuración de tu 
                                        navegador o las herramientas de gestión de cookies.
                                    </p>
                                    <p className="legal-texto-bold">
                                        6. Cambios en la política de cookies
                                    </p>
                                    <p className="legal-texto">
                                        Podemos actualizar esta política de cookies en cualquier momento. 
                                        Te recomendamos que la revises periódicamente para estar al tanto de cualquier cambio.
                                    </p>
                                    <p className="legal-texto-bold">
                                        7. Contacto
                                    </p>
                                    <p className="legal-texto">
                                        Si tienes alguna pregunta sobre nuestra política de cookies, no dudes en contactarnos en protecciondedatos@hyundai.com.ec
                                    </p>
                                    <br></br>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
            <br></br>
            <br></br>
        </Fragment>
    );
}
export default InfoRescueSheets;